<template>
  <div class="activity-min-height">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>活动信息</el-breadcrumb-item>
      <el-breadcrumb-item v-if="!isInMyActivityPage">活动申报</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: isDealer ? '/ActivityInformation' : '/ApprovalQuery'}" v-if="isInMyActivityPage">我的活动</el-breadcrumb-item>
      <el-breadcrumb-item v-if="isInMyActivityPage">活动详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="g-content-box apply-form-box page-content">
      <ActivityForm
        ref="activityForm"
        :isInMyActivityPage="isInMyActivityPage"
        :needDiabled="needDiabled"
        :canEdit="canEdit"
        :productsArr="products"
        :discountsDisabled="discountsDisabled"
        @on-way-change="onWayChange"
        @on-add-product="onAddProduct"
        @on-add-template-data="onAddTemplateData"
        @on-excel-data="onHandleExcelData"
        @on-change-shop="onChangeShop"
        :ruleForm="ruleForm"
      >
        <div v-if="isInMyActivityPage && ruleForm.campaignway === 2">
          <ActivityState :state="getState(getActivityInfoDetail.list[0])"/>
          <span @click="onOpenLog(getActivityInfoDetail.list[0])" class="log-text">
            日志
          </span>
        </div>
      </ActivityForm>
      <div style="margin-top:20px" class="decalare-table-wrapper" v-if="mode !== 2">
        <ActivityTable
          ref="activityTable"
          :data="products"
          :isInMyActivityPage="isInMyActivityPage"
          :headerData="headerData"
          :canEdit="canEdit"
          :mode="mode"
          class="activityTable">
          <template v-slot:operate="scope">
            <el-button v-if="canEdit && scope.data.row.productresult !== '1'" size="small" @click="onDeleteProduct(scope.data)" type="plain" icon="el-icon-remove-outline"></el-button>
            <el-row v-if="!canEdit || scope.data.row.productresult === '1'" type="flex" justify="space-between">
              <ActivityState :state="getState(scope.data.row)"/>
              <span @click="onOpenLog(scope.data.row)" class="log-text">
                日志
              </span>
            </el-row>
          </template>
        </ActivityTable>
      </div>
      <ProductDialog
        :data="productData"
        :visible="productVisible"
        :products="products"
        :isInMyActivityPage="isInMyActivityPage"
        @on-close="onCloseProductDialog"
        @on-finish-product="onCloseProductDialog"
        ref="productDialog"
        @fatherBlur="inputBlur"
      />
      <ActivityLog
        :visible="logVisible"
        :isMyActivity="isInMyActivityPage"
        @on-close="logVisible = false"
        :data="logData"
        :motherData="logMotherData"
      />
      <div class="g-center add-apply-btn-box" @click="onAddOrDeleteRow({flag: 1})" v-if="mode === 1 && canEdit">
        <span><i class="el-icon-plus"></i> 添加一行</span>
      </div>
      <div v-if="canEdit" class="g-margin-top">
        <el-button :loading="isCommiting" class="apply-footer" size="small" type="primary" @click="onComfirmForm">提交</el-button>
        <el-button v-if="isInMyActivityPage" size="small" type="plain" @click="onChangeToMyActivity">取消</el-button>
        <el-button v-if="mode === 0" size="small" type="plain" @click="onOpenTemplateDialog">保存为模板</el-button>
      </div>
      <div v-if="!canEdit && needModifyBtn" class="g-margin-top">
        <el-button size="small" @click="onEditActivity" type="plain">修改活动信息</el-button>
      </div>
      <el-dialog
        title='填写活动模板名称'
        :visible.sync="templateVisible"
        :close-on-click-modal="false"
  			width="640px"
        id="activityDeclarationdialog">
        <el-form :model="templateForm" ref="form" label-width="100px">
          <el-form-item label="模板名称" required>
            <el-input v-model="templateForm.templatename" size="small" clearable></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer">
  				<el-button size="small" type="primary" @click="onSaveTemplate('add')">确 定</el-button>
  				<el-button size="small" type="TheCustom" @click="templateVisible = false">取 消</el-button>
  			</span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import LogMixin from '@/mixins/logMixin';
import ActivityLog from 'components/activityOperate/activityLog';
import { mapState, mapGetters, mapActions } from 'vuex';
import _ from 'lodash';
import Breadcrumb from 'components/breadcrumb/breadcrumb'
import { handleProductUrl } from '@/libs'
import ProductDialog from 'components/productDialog/productDialog2';
import ActivityTable from 'components/activityTable/activityTable';
import ActivityForm from 'components/activityForm/activityForm';
import ActivityState from 'components/activityState/activityState';
import ActivityMixin from '@/mixins/activityMixin.js';
export default {
  name: 'ActivityDeclaration',

  mixins: [
    ActivityMixin,
    LogMixin
  ],

  components:{
    Breadcrumb,
    ActivityTable,
    ProductDialog,
    ActivityForm,
    ActivityState,
    ActivityLog
  },

  data () {
    return {
      cacheProducts: [],
      discountsDisabled: true,
      needModifyBtn: false,
      isDealer: false,
      isInMyActivityPage: false,
      details: {},
      templateForm: {
        templatename: ''
      },
      templateVisible: false,
      needDiabled: false,
      ruleForm: {
        preheating_time: '',
        campaignway: 0,
        campaign_name: '',
        times: [],
        campaign_desc: '',
        shop_id: [],
        discounts: 10,
        attachment: ''
      },
      canEdit: true,
      // isMyActivity: false,
      isCommiting: false,
      selectTemplateId: "",
      breadcrumbArray: ['活动信息', '活动申报'],
      shopname: ''
    }
  },

  methods: {
    inputBlur() {
      console.log('调用')
      this.newAdd()
    },
    // 新增监控产品
    newAdd() {
      let params = {
        pageNum: 1,
        pageSize: 10000,
      }
      fetch({
        url: "hcm/ProductClassify/seletProductClassify",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
          this.productData = res.data.data.list
          console.log(this.productData)
          this.$refs.productDialog.open(res.data.data.list)
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      })
    },
    onChangeShop(productData) {
      this.newAdd()
      // this.productData = productData;
    },
    onHandleExcelData(data) {
      if(!this.products.length) {
        this.products.push(...data.excelData)
      }
      if(data.flag === '1') {
        this.products = data.excelData;
      }else {
        this.products.push(...data.excelData)
      }
    },
    // 需要修改活动信息的按钮
    judgeModifyBtn(data) {
      // 全部通过
      function allPass() {
        return data.list.every(item => {
          return item.productresult === '1';
        })
      }
      if(data.details.campaign_node === '已审批' && allPass()) {
        this.needModifyBtn = false;
      }else {
        this.needModifyBtn = true;
      }
    },
    onChangeToMyActivity() {
      this.products = this.cacheProducts;
      this.canEdit = false;
      this.needDiabled = true;
    },
    onOpenTemplateDialog() {
      const vaildTable = this.$refs['activityTable'].validTable();
      if(vaildTable) {
        this.templateVisible = true;
      }
    },
    onEditActivity() {
      this.rejecteds = [];
      if(this.getActivityInfoDetail.details.campaignway === 2) {
        (this.getActivityInfoDetail.list[0].productresult === '2' || !this.getActivityInfoDetail.list[0].productresult) && (this.discountsDisabled = false)
        console.log(this.discountsDisabled);

      }
      this.details.campaign_node === '待审批' && (this.needDiabled = false);
      this.canEdit = true;
      // 缓存一份products
      this.cacheProducts = this.products;
      const cloneProducts = _.cloneDeep(this.products);
      this.products = [];
      cloneProducts.forEach(product => {
        !product.actual_price && (product.actual_price = undefined);
        !product.apply_price && (product.apply_price = undefined);
        !product.estimated_sales && (product.estimated_sales = undefined);
        !product.sales && (product.sales = undefined);
        this.products.push(product);
      })
      console.log(this.products);

    },
    getState(row) {
      if(row.campaign_node === '待审批') {
        return row.campaign_node;
      }else if(row.productresult === '1'){
        return '已通过';
      }else {
        return '已驳回';
      }
    },

    onCreateNewTemplate() {
      this.$router.push('/Brand/floatingPlaten/main')
    },
    async onComfirmForm() {
      const vaildForm = await this.$refs['activityForm'].validForm();
      const formData = this.$refs['activityForm'].getFormData();
      // ruleForm.campaign_desc
      console.log(formData.cashbacknumone)
      console.log(formData.eachcashbackone)
      console.log(formData.discounts)
      if (formData.cashbacknumone || formData.eachcashbackone) {

      } else {
        if(!vaildForm) {
          return;
        }
      }
      // console.log(vaildForm)
      // if(!vaildForm) {
      //   return;
      // }
      let data;

      // 如果全店铺申报，整理出data
      if(this.mode === 2) {
        if(vaildForm || formData.cashbacknumone || formData.eachcashbackone) {
          let cplist
          if (formData.discounts) {
            cplist = [{
              discounts: formData.discounts
            }]
          } else if (formData.cashbacknumone) {
            cplist = [{
              cashbacknumone: formData.cashbacknumone,
              cashbacknumtwo: formData.cashbacknumtwo,
              cashback: formData.cashback,
            }]
          } else if (formData.eachcashbackone) {
            cplist = [{
              eachcashbackone: formData.eachcashbackone,
              eachcashbacktwo: formData.eachcashbacktwo,
              eachcashback: formData.eachcashback,
            }]
          }
          delete formData.discounts;
          data = {
            ...formData,
            cplist
          }
        } else {
          return;
        }
      }else if(vaildForm) {
        // 按产品和按链接申报先验证下面的表单
        const vaildTable = this.$refs['activityTable'].validTable();
        if(vaildTable) {
          // 获取表单数据
          let cplist = this.$refs['activityTable'].getTableData();
          data = {
            ...formData,
          }
          if(this.isInMyActivityPage) {
            // 把重新编辑提交的驳回条数放进去
            if(this.getActivityInfoDetail.details.campaign_node === '审批中') {
              const list = this.getActivityInfoDetail.list.filter(item => item.productresult === '1' || item.productresult === '2')
              data.rejectednumber = list.length;
            }
            // 将老数据和新数据对比，看哪些是修改过的
            if(this.mode <= 1 && this.getActivityInfoDetail.details.campaign_node === '已审批') {
              const backData = this.getActivityInfoDetail.list.filter(item => item.productresult === '2');
              const modifyCplist = cplist.filter((item, index) => {
                const hasModify = this.headerData.some(header => {
                  if(cplist[index][header.key] != backData[index][header.key]) {
                    return true;
                  }else {

                    return false;
                  }
                })
                console.log(hasModify);
                if(hasModify) {
                  this.rejecteds.push(backData[index].hid);
                }

                return hasModify;
              })

              data.cplist = modifyCplist
            }
            // 添加编辑时删除了产品的id
            if(this.mode <= 1 && this.rejecteds.length && this.getActivityInfoDetail.details.campaign_node === '已审批') {
              data.rejecteds = this.rejecteds.join(',')
            }
          }

          if(!data.cplist) {
            data.cplist = cplist
          }

        }else {
          return;
        }
      }

      this.isCommiting = true;
      let p;
      if(this.isInMyActivityPage) {
        p = this.reqReApplyActivity;
        data.id = this.details.id;
        data.campaign_node = this.details.campaign_node;
      }else {
        p = this.reqApplyActivity
      }
      console.log(data);
      p(data).then(res => {
        if(res.status === '10000') {
          this.$message({
            showClose: true,
            message: '活动申报成功',
            type: 'success'
          });
          this.$router.push(this.isDealer ? '/ActivityInformation' : '/ApprovalQuery');
        }
        if(res.status === '400') {
          this.$message({
            showClose: true,
            message: `${res.message}`,
            type: 'error'
          });
        }
        this.isCommiting = false;
      }).catch(() => {
        this.isCommiting = false;
      });
    },
    ...mapActions([
      'reqActivityShopProduct',
      'reqShopProductLink',
      'reqIsLowPrice',
      'reqShopInfo',
      'reqApplyActivity',
      'reqActivityDealerShops',
      'reqActivityDecalareTemplateList',
      'reqActivityInfoDetail',
      'reqReApplyActivity',
      'reqActivityFlowWay'
    ]),
    async echoRuleForm(res) {
      const details = res.details;
      this.mode = details.campaignway;
      this.needDiabled = true;
      this.details = details;
      details.times = [`${this.$options.filters['fullTime'](details.start_time)}~${this.$options.filters['fullTime'](details.end_time)}`];
      this.ruleForm = Object.assign({}, this.ruleForm, details);
      if(details.campaignway === 2) {
        this.ruleForm.discounts = res.list[0].discounts;
			}
			console.log(this.ruleForm);

			// 我的活动要根据当时所申报的活动类型回显申报权限
			if(this.isInMyActivityPage) {
				this.$refs['activityForm'].setDeclareWay(details.campaignway);
				// 回显文件列表
				this.$refs['activityForm'].echoAttachments(details.attachment);
			}
    },
    echoMyActivity(res) {
      this.echoRuleForm(res);
      this.echoTableData(res.list, this.ruleForm.campaignway);
    },
  },

  computed: {
    ...mapGetters([
      'getDealerShops',
      'getShopProducts',
      'getProductLink',
      'getUserLoginType',
      'getActivityInfoDetail'
    ]),
    ...mapState({
      activityDecalareTemplateList: state => state.activityDeclaration.activityDecalareTemplateList
    })
  },

  async created() {
    // let aaa = JSON.parse('"{"biaojia":"600","jingjia":"600"}"')
    // console.log(aaa)
    if(this.getUserLoginType === 'DEALER') {
      this.isDealer = true;
      this.reqActivityDealerShops();
    }
    const id = this.$route.params.id

    if(id === ':id') {
      // 请求模板数据
      this.reqActivityDecalareTemplateList({
        pageNo: 1,
        pageSize: 10000,
        declaremeans: String(this.mode)
      })
      // 初始化数据、自定义字段
      this.initProductData(this.mode);
      if(this.getUserLoginType !== 'DEALER') {
        this.reqActivityDealerShops().then(res => {
          this.shopname = res.id;
        });
      }
      this.discountsDisabled = false;
    }else {
      this.canEdit = false;
      this.isInMyActivityPage = true;
      const res = await this.reqActivityInfoDetail({
        id
      });
      this.judgeModifyBtn(res);
      this.echoMyActivity(res);
    }
    !this.isDealer && this.getProductInfo();
  },

  mounted() {
  },
}
</script>


<style lang='scss' scoped>
@import "style/activityDeclaration.scss";
.log-text {
  cursor: pointer;
  color: #108CEE;
}
#activityDeclarationdialog {
  .el-button--primary {
    color: #FFF;
    background-color: #bda571;
    border-color: #bda571;
  }
  .el-button--primary:hover {
    color: #FFF;
    background-color: #c0ae8a;
    border-color: #c0ae8a;
  }
  .el-button--TheCustom {
    color: #666;
    border-color: #D9D9D9;
    background-color: #fff;
  }
  .el-button--TheCustom:hover  {
    color: #666;
    border-color: #ded2b8;
    background-color: #faf9f5;
  }
}

</style>
